export const invoiceUsageOptions = [
  {
    label: 'D01 - Medical and Dental Fees and Hospital Expenses',
    value: '12',
    disabled: true,
  },
  {
    label: 'D02 - Medical Expenses Due to Disability',
    value: '13',
    disabled: true,
  },
  {
    label: 'D03 - Funeral Expenses',
    value: '14',
    disabled: true,
  },
  {
    label: 'D04 - Donations',
    value: '15',
    disabled: true,
  },
  {
    label: 'D05 - Real Interest Actually Paid for Mortgage Loans (House)',
    value: '16',
    disabled: true,
  },
  {
    label: 'D06 - Voluntary Contributions to SAR',
    value: '17',
    disabled: true,
  },
  {
    label: 'D07 - Premiums for Medical Expenses Insurance',
    value: '18',
    disabled: true,
  },
  {
    label: 'D08 - Mandatory School Transportation Expenses',
    value: '19',
    disabled: true,
  },
  {
    label:
      'D09 - Deposits in Accounts for Savings, Premiums Based on Pension Plans',
    value: '20',
    disabled: true,
  },
  {
    label: 'D10 - Payments for Educational Services (Tuition Fees)',
    value: '21',
    disabled: true,
  },
  {
    label: 'G01 - Adquisición de Mercancías',
    value: '1',
    disabled: false,
  },
  {
    label: 'G02 - Devoluciones, Descuentos o Bonificaciones',
    value: '2',
    disabled: false,
  },
  {
    label: 'G03 - Gastos en General',
    value: '3',
    disabled: false,
  },
  {
    label: 'I01 - Construcciones',
    value: '4',
    disabled: false,
  },
  {
    label: 'I02 - Mobiliario y Equipo de Oficina por Inversiones',
    value: '5',
    disabled: false,
  },
  {
    label: 'I03 - Equipo de Transporte',
    value: '6',
    disabled: false,
  },
  {
    label: 'I04 - Equipo de Cómputo y Accesorios',
    value: '7',
    disabled: false,
  },
  {
    label: 'I05 - Dados, Troqueles, Moldes, Matrices y Herramental',
    value: '8',
    disabled: false,
  },
  {
    label: 'I06 - Comunicaciones Telefónicas',
    value: '9',
    disabled: false,
  },
  {
    label: 'I07 - Comunicaciones Satelitales',
    value: '10',
    disabled: false,
  },
  {
    label: 'I08 - Otra Maquinaria y Equipo',
    value: '11',
    disabled: false,
  },
  {
    label: 'P01 - Por Definir',
    value: '22',
    disabled: false,
  },
];

export const satPaymentMethodOptions = [
  {
    label: '01 - Efectivo',
    value: '1',
    disabled: false,
  },
  {
    label: '02 - Check',
    value: '2',
    disabled: true,
  },
  {
    label: '03 - Transferencia Electrónica de Fondos',
    value: '3',
    disabled: false,
  },
  {
    label: '04 - Tarjeta de Crédito',
    value: '4',
    disabled: false,
  },
  {
    label: '05 - Electronic Wallet',
    value: '5',
    disabled: true,
  },
  {
    label: '06 - Electronic Money',
    value: '6',
    disabled: true,
  },
  {
    label: '07 - Digital Cards',
    value: '7',
    disabled: true,
  },
  {
    label: '08 - Meal Vouchers',
    value: '8',
    disabled: true,
  },
  {
    label: '09 - Goods',
    value: '9',
    disabled: true,
  },
  {
    label: '10 - Service',
    value: '10',
    disabled: true,
  },
  {
    label: '11 - Third-party Payment',
    value: '11',
    disabled: true,
  },
  {
    label: '12 - Giving in Payment',
    value: '12',
    disabled: true,
  },
  {
    label: '13 - Payment by Subrogation',
    value: '13',
    disabled: true,
  },
  {
    label: '14 - Payment by Consignment',
    value: '14',
    disabled: true,
  },
  {
    label: '15 - Condonation',
    value: '15',
    disabled: true,
  },
  {
    label: '16 - Cancellation',
    value: '16',
    disabled: true,
  },
  {
    label: '17 - Compensation',
    value: '17',
    disabled: true,
  },
  {
    label: '23 - Novation',
    value: '18',
    disabled: true,
  },
  {
    label: '24 - Netting',
    value: '19',
    disabled: true,
  },
  {
    label: '25 - Debt Remittance',
    value: '20',
    disabled: true,
  },
  {
    label: '26 - Prescription or Expiration',
    value: '21',
    disabled: true,
  },
  {
    label: '27 - To the Satisfaction of the Creditor',
    value: '22',
    disabled: true,
  },
  {
    label: '28 - Tarjeta de Débito',
    value: '23',
    disabled: false,
  },
  {
    label: '29 - Service Card',
    value: '24',
    disabled: true,
  },
  {
    label: '30 - Advance Payment',
    value: '25',
    disabled: true,
  },
  {
    label: '31 - Payment Intermediary',
    value: '26',
    disabled: true,
  },
  {
    label: '98 - N/A',
    value: '27',
    disabled: true,
  },
  {
    label: '99 - To be Defined',
    value: '28',
    disabled: true,
  },
];

export const stateOptions = [
  {
    label: 'Aguascalientes',
    value: 'AGS',
  },
  {
    label: 'Baja California',
    value: 'BC',
  },
  {
    label: 'Baja California Norte (obsolete)',
    value: 'BCN',
  },
  {
    label: 'Baja California Sur',
    value: 'BCS',
  },
  {
    label: 'Campeche',
    value: 'CAM',
  },
  {
    label: 'Chiapas',
    value: 'CHIS',
  },
  {
    label: 'Chihuahua',
    value: 'CHIH',
  },
  {
    label: 'Coahuila',
    value: 'COAH',
  },
  {
    label: 'Colima',
    value: 'COL',
  },
  {
    label: 'Distrito Federal (obsolete)',
    value: 'DF',
  },
  {
    label: 'Durango',
    value: 'DGO',
  },
  {
    label: 'Guanajuato',
    value: 'GTO',
  },
  {
    label: 'Guerrero',
    value: 'GRO',
  },
  {
    label: 'Hidalgo',
    value: 'HGO',
  },
  {
    label: 'Jalisco',
    value: 'JAL',
  },
  {
    label: 'Mexico City',
    value: 'CDMX',
  },
  {
    label: 'Michoacán',
    value: 'MICH',
  },
  {
    label: 'Morelos',
    value: 'MOR',
  },
  {
    label: 'México (Estado de)',
    value: 'MEX',
  },
  {
    label: 'Nayarit',
    value: 'NAY',
  },
  {
    label: 'Nuevo León',
    value: 'NL',
  },
  {
    label: 'Oaxaca',
    value: 'OAX',
  },
  {
    label: 'Puebla',
    value: 'PUE',
  },
  {
    label: 'Querétaro',
    value: 'QRO',
  },
  {
    label: 'Quintana Roo',
    value: 'QROO',
  },
  {
    label: 'San Luis Potosí',
    value: 'SLP',
  },
  {
    label: 'Sinaloa',
    value: 'SIN',
  },
  {
    label: 'Sonora',
    value: 'SON',
  },
  {
    label: 'Tabasco',
    value: 'TAB',
  },
  {
    label: 'Tamaulipas',
    value: 'TAMPS',
  },
  {
    label: 'Tlaxcala',
    value: 'TLAX',
  },
  {
    label: 'Veracruz',
    value: 'VER',
  },
  {
    label: 'Yucatán',
    value: 'YUC',
  },
  {
    label: 'Zacatecas',
    value: 'ZAC',
  },
];
